<section class="summarization-page">

  <div
    class="summarization-layout"
    [class.left-collapsed]="isLeftPanelCollapsed"
  >

    <!-- =====================================================
         LEFT 50%
    ====================================================== -->
    <aside class="summary-left-panel">

      <div class="left-panel-card">

        <!-- Left Header -->
        <div class="panel-header">

          <div class="panel-header-icon">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
          </div>

          @if (!isLeftPanelCollapsed) {

            <div class="panel-header-content">

              <h4>AI Summarizer</h4>

              <p>
                Add content to create a concise summary.
              </p>

            </div>

          }

          <!-- Collapse Button -->
          <button
            type="button"
            class="panel-collapse-button"
            (click)="toggleLeftPanel()"
            [attr.aria-label]="
              isLeftPanelCollapsed
                ? 'Expand input panel'
                : 'Collapse input panel'
            "
          >
            <i
              class="fa-solid"
              [class.fa-chevron-left]="!isLeftPanelCollapsed"
              [class.fa-chevron-right]="isLeftPanelCollapsed"
            ></i>
          </button>

        </div>


        @if (!isLeftPanelCollapsed) {

          <!-- Input -->
          <div class="summary-input-area">

            <div class="input-section-title">

              <span class="title-icon">
                <i class="fa-solid fa-file-lines"></i>
              </span>

              <div>
                <strong>Add your content</strong>

                <span>
                  Enter text or upload a document
                </span>
              </div>

            </div>


            <div class="summarize-input-wrapper">

              <app-summarize-content
                (summaryResponse)="summaryResponse($event)"
              >
              </app-summarize-content>

            </div>

          </div>


          <!-- Security -->
          <div class="secure-card">

            <div class="secure-icon">
              <i class="fa-solid fa-shield-halved"></i>
            </div>

            <div class="secure-content">

              <strong>Secure processing</strong>

              <span>
                Your content is processed securely and privately.
              </span>

            </div>

            <i class="fa-solid fa-check secure-check"></i>

          </div>


          <!-- Footer -->
          <div class="left-panel-footer">

            <div>
              <i class="fa-solid fa-lock"></i>
              Private
            </div>

            <div>
              <i class="fa-solid fa-bolt"></i>
              AI Powered
            </div>

            <div>
              <i class="fa-solid fa-file"></i>
              Documents
            </div>

          </div>

        } @else {

          <!-- Collapsed State -->
          <div class="left-collapsed-content">

            <div class="collapsed-icon">
              <i class="fa-solid fa-file-lines"></i>
            </div>

            <span>
              Input
            </span>

            <small>
              Add content
            </small>

          </div>

        }

      </div>

    </aside>


    <!-- =====================================================
         RIGHT 50%
    ====================================================== -->
    <main class="summary-right-panel">

      <div class="results-card">

        <!-- Results Header -->
        <div class="results-header">

          <div class="results-header-left">

            <div class="results-icon">
              <i class="fa-solid fa-layer-group"></i>
            </div>

            <div>

              <div class="results-title-row">

                <h4>
                  Generated Summaries
                </h4>

                @if (summarizationDataList.length > 0) {

                  <span class="result-badge">
                    {{ summarizationDataList.length }}
                  </span>

                }

              </div>

              <p>
                Review your AI-generated summaries
              </p>

            </div>

          </div>


          @if (summarizationDataList.length > 0) {

            <div class="results-actions">

              <button
                type="button"
                class="action-button"
                (click)="expandAll()"
              >
                <i class="fa-solid fa-angles-down"></i>
                <span>Expand all</span>
              </button>

              <button
                type="button"
                class="action-button"
                (click)="collapseAll()"
              >
                <i class="fa-solid fa-angles-up"></i>
                <span>Collapse all</span>
              </button>

            </div>

          }

        </div>


        <!-- Summary List -->
        @if (summarizationDataList.length > 0) {

          <div class="summary-list">

            @for (
              summary of summarizationDataList;
              track summary;
              let i = $index
            ) {

              <div
                class="summary-item"
                [class.expanded]="isSummaryExpanded(i)"
              >

                <button
                  type="button"
                  class="summary-item-header"
                  (click)="toggleSummary(i)"
                  [attr.aria-expanded]="isSummaryExpanded(i)"
                >

                  <div class="summary-item-left">

                    <div class="summary-index">
                      {{ i + 1 }}
                    </div>

                    <div class="summary-item-info">

                      <!-- <span class="summary-label">
                        AI SUMMARY
                      </span> -->

                      <strong>
                        Generated Summary
                      </strong>

                      <div class="summary-status">

                        <span>
                          <i class="fa-solid fa-circle-check"></i>
                          Ready
                        </span>

                        <span>
                          <i class="fa-regular fa-clock"></i>
                          Generated
                        </span>

                      </div>

                    </div>

                  </div>


                  <div class="summary-item-right">

                    <span class="view-text">
                      {{
                        isSummaryExpanded(i)
                          ? 'Hide'
                          : 'View'
                      }}
                    </span>

                    <span class="toggle-icon">

                      <i
                        class="fa-solid"
                        [class.fa-chevron-up]="isSummaryExpanded(i)"
                        [class.fa-chevron-down]="!isSummaryExpanded(i)"
                      ></i>

                    </span>

                  </div>

                </button>


                @if (isSummaryExpanded(i)) {

                  <div class="summary-item-body">

                    <div class="summary-body-header">

                      <!-- <div>

                        <span>
                          SUMMARY CONTENT
                        </span>

                        <h5>
                          AI Generated Summary
                        </h5>

                      </div> -->

                      <!-- <div class="ready-status">
                        <span></span>
                        Ready
                      </div> -->

                    </div>

                    <div class="summary-content">

                      <app-summarize-data-list
                        [summary]="summary"
                      >
                      </app-summarize-data-list>

                    </div>

                  </div>

                }

              </div>

            }

          </div>

        }


        <!-- Empty -->
        @if (summarizationDataList.length === 0) {

          <div class="empty-results">

            <div class="empty-icon-wrapper">

              <div class="empty-icon">
                <i class="fa-solid fa-file-circle-plus"></i>
              </div>

              <span class="empty-spark spark-one">
                <i class="fa-solid fa-sparkles"></i>
              </span>

              <span class="empty-spark spark-two">
                <i class="fa-solid fa-star"></i>
              </span>

            </div>

            <h4>
              No summaries yet
            </h4>

            <p>
              Add content from the left panel and generate
              your first AI-powered summary.
            </p>

            <div class="empty-action">

              <i class="fa-solid fa-arrow-left"></i>

              <span>
                Start by adding your content
              </span>

            </div>

          </div>

        }


        <!-- <div class="pagination-area">

          <pagination-loader
            [showFetchLoader]="showPaginateSpinner"
          >
          </pagination-loader>

        </div> -->

      </div>

    </main>

  </div>

</section>
